/**
 * Utility function to transform Gravatar URLs to use our proxy
 * This helps avoid CORS issues with Gravatar images
 */

/**
 * Transforms a Gravatar URL to use our proxy endpoint
 * @param {string} url - The original Gravatar URL
 * @returns {string} - The proxied URL
 */
export const proxyGravatarUrl = (url) => {
  if (!url) return url;
  
  // Check if this is a Gravatar URL
  const gravatarRegex = /https?:\/\/(secure\.)?gravatar\.com\/avatar\/([a-f0-9]{32})(\.png|\.jpg)?(.*)/i;
  const match = url.match(gravatarRegex);
  
  if (match) {
    // Extract the hash from the URL
    const hash = match[2];
    // Use our proxy endpoint
    return `/avatar-proxy/${hash}`;
  }
  
  // If it's not a Gravatar URL, return it unchanged
  return url;
};

/**
 * Hook to use in components that display avatars
 * @param {string} originalUrl - The original avatar URL
 * @returns {string} - The possibly proxied URL
 */
export const useProxiedAvatar = (originalUrl) => {
  return proxyGravatarUrl(originalUrl);
};
